import { getQueryStringParameter } from 'owa-querystring';
import type { MiniHostApps } from './types/MiniHostApps';

export const getOpxHostAppName = () =>
    getQueryStringParameter('hostApp')?.toLowerCase() as MiniHostApps;
